﻿<script>
    import Panzoom from '@panzoom/panzoom';
    
    export default {
        name: 'journey-composer-zoom',
        mounted() {
            const vm = this;
            
            vm.panzoom = Panzoom(vm.$el, { 
                excludeClass: 'composer-component'
            });
            
            vm.defaultPan = vm.panzoom.getPan();
            
            //Event listeners have to be added 'manually'
            vm.$el.addEventListener('panzoomzoom', vm.handleZoom);
            
            if(!vm.proxy){
                vm.$el.addEventListener('wheel', vm.zoomWithWheel);
                vm.$el.addEventListener('panzoompan', vm.handlePan);
            }
            else{
                vm.$el.addEventListener('wheel', vm.proxyZoomWithWheel);
                vm.$el.addEventListener('panzoompan', vm.proxyPan);

                //Pan parameters are always relative to current 'pan' session
                //thus we need to reset our 'previousPan' upon session 'end'
                vm.$el.addEventListener('panzoomend', () => vm.previousPan = vm.defaultPan);
            }
        },
        render(createElement, context) {
            return this.$slots.default;
        },
        methods: {
            proxyZoomWithWheel(){
                this.$emit('proxy-zoom-with-wheel', ...arguments);  
            },
            proxyPan(){
                const vm = this;

                const panSession = vm.panzoom.getPan();
                
                const {x: sessionX, y: sessionY} = panSession;
                const {x: previousX, y: previousY} = vm.previousPan;
                const {x: defaultX, y: defaultY} = vm.defaultPan;
                
                //Ensure we don't trigger an infinite loop when resetting our pan
                if(sessionX !== defaultX || sessionY !== defaultY){
                    //Prvent our proxied element from panning panning
                    vm.panzoom.pan(defaultX, defaultY);
                    
                    vm.previousPan = panSession;

                    //Diff between current/previous
                    //this can be added to the 'current' pan by the element receiving the data 
                    this.$emit('proxy-add-pan', {
                        x: sessionX - previousX,
                        y: sessionY - previousY
                    });
                }
            },
            addPan({x, y}){
                const vm = this;
                const pan = vm.panzoom.getPan();
                
                this.panzoom.pan(pan.x + x, pan.y + y);
            },
            zoomWithWheel(){
                if(this.panzoom){
                    this.panzoom.zoomWithWheel(...arguments);
                }
            },
            handlePan(){
                const pan = this.panzoom.getPan();
                const scale = this.panzoom.getScale();
                
                this.$emit('pan-changed', {
                    scale: scale,
                    x: pan.x,
                    y: pan.y
                });
            },
            handleZoom({detail}){
                this.$emit('scale-changed', detail);
            }
        },
        props: {
            proxy: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            panzoom: null,
            defaultPan: { x: 0, y: 0 },
            previousPan: { x: 0, y: 0 }
        })
    }
</script>
